<template>
  <div class="HSelectcode">
    <el-select
      filterable
      @change="selectChange"
      :clearable="clearable"
      :multiple="multiple"
      v-model="selectValue"
      :placeholder="placeholder"
      :disabled="disabled"
      collapse-tags
      collapse-tags-tooltip
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :value="item.code"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { defineComponent, watchEffect, reactive, toRefs, nextTick } from "vue";
import { getDict } from "@/api/constant";
export default defineComponent({
  name: "HSelectcode",
  components: {},
  props: {
    dictData: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    modelValue: {},
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bx: {
      type: String,
      default: "",
    },
    zw: {
      type: String,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const state = reactive({
      selectValue: "",
      options: [],
    });
    const methods = {
      async codeAxios(code) {
        let res = null;
        if (props.dictData) {
          res = props.dictData;
        } else {
          res = await getDict(code);
        }
        const list = [];
        if (props.bx === "bx") {
          list.push({
            value: "不限",
            code: "",
          });
        }
        state.options = list.concat(res.dict);
      },
      selectChange(val) {
        emit("change", val, state.options);
        emit("update:modelValue", val);
        console.log(val);
        if (val) {
          for (let index = 0; index < state.options.length; index++) {
            const element = state.options[index];
            if (element.code === val) {
              emit("update:zw", element.value);
              return;
            }
          }
        } else {
          emit("update:zw", "");
        }

        console.log(val);
      },
    };
    watchEffect(() => {
      state.selectValue = props.modelValue;
    });
    watchEffect(() => {
      if (props.dictData && props.dictData.dict) {
        nextTick(() => {
          methods.codeAxios(props.type);
        });
      }
    });
    methods.codeAxios(props.type);
    return {
      ...toRefs(state),
      ...methods,
    };
  },
});
</script>
<style lang="scss" scoped>
.HSelectcode {
  width: 100%;
  height: 100%;
  /deep/ .el-select {
    width: 100%;
  }
  /deep/ .el-input__inner {
    width: 100%;
  }
  /deep/ .el-select__tags {
    display: block;
  }
}
</style>
